<template>
    <a-modal
        :class="'modal epic-' + moduleStateLink"
        :title="$t('admin.association_settings.modal.remove_association_modal.title')"
        :destroyOnClose="true"
        v-model:open="modal_visible"
        width="auto"
        :dialog-style="{ padding: '0 20px', maxWidth: '720px' }"
        :maskClosable="!processing"
        :closable="!processing"
    >
        <p>
            {{ $t('admin.association_settings.modal.remove_association_modal.content', { code: association_code }) }}
        </p>
        <ui-input v-model="confirm_text" />
        <template #footer>
            <a-button data-cy="cancel-button" type="default" key="cancel" @click="hideModal">
                {{ $t('admin.association_settings.modal.remove_association_modal.cancel') }}
            </a-button>
            <a-button
                key="submit"
                class="remove_button"
                type="danger"
                data-cy="admin-remove-association"
                :loading="processing"
                @click="handleSubmit"
                :disabled="cannotProceed"
            >
                {{ $t('admin.association_settings.modal.remove_association_modal.submit') }}
            </a-button>
        </template>
    </a-modal>
</template>

<script>
import UiInput from '@/components/ui/Input.vue';

export default {
    components: {
        UiInput,
    },
    data() {
        return {
            modal_visible: false,
            confirm_text: '',
        };
    },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        association_code: {
            type: String,
            default: '',
        },
    },
    computed: {
        moduleStateLink() {
            return this.$store.state.system.is_epicvault_enabled ? 'default' : 'claim';
        },
        cannotProceed() {
            return this.association_code !== this.confirm_text || this.association_code.length === 0;
        },
    },
    methods: {
        showModal() {
            this.confirm_text = '';
            this.modal_visible = true;
        },
        hideModal() {
            this.modal_visible = false;
        },
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
